/**
 * Copy and app links for the "available in the Joshua app" notice (JOSH-91).
 *
 * A view on the mobile channel only counts as absent on web. Instead of
 * "Acesso Negado", web entrances to that recurso hand the person over to the
 * app. Pure helpers, kept apart from the component so they are unit-testable.
 */

/** Scheme registered by the Ops app (apps/ops/app.json `scheme`). */
export const APP_SCHEME = 'joshua://';

export interface AvisoOutroCanalCopy {
  /** Page header on a route ("Ordens de Serviço"). */
  rotuloRota: string;
  /** Drawer header ("Ordem de Serviço"). */
  rotuloDrawer: string;
  /** Route title. */
  tituloRota: string;
  /** Drawer title. */
  tituloDrawer: string;
  /** Route body text. */
  texto: string;
  /** Where to find the content in the app, shown under the button. */
  ondeNoApp: string;
}

const COPY_POR_RECURSO: Record<string, AvisoOutroCanalCopy> = {
  OS: {
    rotuloRota: 'Ordens de Serviço',
    rotuloDrawer: 'Ordem de Serviço',
    tituloRota: 'Suas Ordens de Serviço estão disponíveis no app Joshua',
    tituloDrawer: 'Esta OS está disponível no app Joshua',
    texto: 'No seu perfil, as Ordens de Serviço são usadas pelo app Joshua, no celular.',
    ondeNoApp: 'No app Joshua, abra a aba Ordem de Serviço.',
  },
  REQUISICAO: {
    rotuloRota: 'Requisições',
    rotuloDrawer: 'Requisição',
    tituloRota: 'Suas Requisições estão disponíveis no app Joshua',
    tituloDrawer: 'Esta requisição está disponível no app Joshua',
    texto: 'No seu perfil, as Requisições são usadas pelo app Joshua, no celular.',
    ondeNoApp: 'No app Joshua, abra a aba Requisição.',
  },
};

const COPY_GENERICA: AvisoOutroCanalCopy = {
  rotuloRota: 'App Joshua',
  rotuloDrawer: 'App Joshua',
  tituloRota: 'Esta tela está disponível no app Joshua',
  tituloDrawer: 'Este conteúdo está disponível no app Joshua',
  texto: 'No seu perfil, esta tela é usada pelo app Joshua, no celular.',
  ondeNoApp: 'Abra o app Joshua no celular para continuar.',
};

export function copyDoAviso(recurso: string): AvisoOutroCanalCopy {
  return COPY_POR_RECURSO[recurso.toUpperCase()] ?? COPY_GENERICA;
}

/** App routes that open one record (apps/ops deepLinkService). */
const ROTA_NO_APP: Record<string, string> = {
  OS: 'os',
  REQUISICAO: 'requisicao',
};

/**
 * Link that opens the app: on the record when the recurso has an app route and
 * an id is known, otherwise on the app's start screen.
 */
export function linkDoApp(recurso: string, registroId?: string | null): string {
  const rota = ROTA_NO_APP[recurso.toUpperCase()];
  if (!rota || !registroId) return APP_SCHEME;
  return `${APP_SCHEME}${rota}/${encodeURIComponent(registroId)}`;
}
